<i18n>
{
  "fr": {
    "label": "Supprimer le compte",
    "confirm": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible."
  }
}
</i18n>

<template>
  <button class="base-btn base-btn--link" type="button" @click="onClick">
    {{ $t('label') }}
  </button>
</template>

<script>
let form = null;

export default {
  name: 'CustomerDeleteButton',
  props: {
    action: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.initForm();
  },
  methods: {
    initForm() {
      form = document.createElement('form');
      form.action = this.action;
      form.method = 'post';

      var csrf = document.createElement('input');
      csrf.type = 'hidden';
      csrf.name = '_token';
      csrf.value = document.querySelector('meta[name="csrf-token"]').content;

      form.appendChild(csrf);

      var method = document.createElement('input');
      method.type = 'hidden';
      method.name = '_method';
      method.value = this.method;

      form.appendChild(method);

      document.body.appendChild(form);
    },
    onClick() {
      if (window.confirm(this.$t('confirm'))) {
        form.submit();
      }
    },
  },
};
</script>
